import PropTypes from 'prop-types';

const ClockIcon = ({ className = '' }) => (
  <svg
    width="80"
    height="80"
    viewBox="0 0 80 80"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M72 0H8C3.58172 0 0 3.58172 0 8V72C0 76.4183 3.58172 80 8 80H72C76.4183 80 80 76.4183 80 72V8C80 3.58172 76.4183 0 72 0Z"
      fill="#FFCCEF"
    />
    <path
      d="M40.0001 74.2853C58.9355 74.2853 74.2858 58.9351 74.2858 39.9996C74.2858 21.0641 58.9355 5.71387 40.0001 5.71387C21.0646 5.71387 5.71436 21.0641 5.71436 39.9996C5.71436 58.9351 21.0646 74.2853 40.0001 74.2853Z"
      fill="white"
    />
    <path
      d="M46.8238 16.0742H33.1753V33.1759H46.8238V16.0742Z"
      fill="#FB6E44"
    />
    <path
      d="M46.8238 33.1748H33.1753V46.8233H46.8238V33.1748Z"
      fill="#FB6E44"
    />
    <path
      d="M64.0905 33.1748H46.8242V46.8233H64.0905V33.1748Z"
      fill="#0A0777"
    />
  </svg>
);

ClockIcon.propTypes = {
  className: PropTypes.string
};

export default ClockIcon;
